export default __webpack_public_path__ + "static/media/img2.143dbc97.jpg";